import {
  Box,
  Circle,
  Flex,
  HStack,
  Icon,
  Text,
  VStack,
  Link as ChakraLink,
} from "@chakra-ui/react";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

// Importing all necessary icons from react-icons
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaUsers,
  FaFileInvoice,
  FaLock,
  FaFileContract,
  FaUndoAlt,
  FaPlane,
  FaBookOpen,
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";
import { GrMail } from "react-icons/gr";
import { IoTimeOutline } from "react-icons/io5";

// Using the original image paths as provided
import logo from "../../../images/logo/logo-combined.png";
import aita from "../../../images/footer/aita-img.jpg"; // Your original JPG image
import Toab from '../../../images/footer/toab.png'; // Your original PNG image

// Data for the "Contact Us" column with icons
const contactData = [
  {
    icon: FaMapMarkerAlt,
    text: `Sharif Plaza (5th Floor), 39 Kemal Ataturk Avenue, Banani, Dhaka-1213`,
    link: "https://maps.app.goo.gl/DLrV8EpyiGuv6xUR6",
    isExternal: true,
  },
  {
    icon: GrMail,
    text: "reservation@travelchamp.com",
    link: "mailto:reservation@travelchamp.com",
    isExternal: true,
  },
  {
    icon: FaPhoneAlt,
    text: "+8809613335566",
    link: "tel:+8809613335566",
    isExternal: true,
  },
  {
    icon: IoTimeOutline,
    text: "Our Service 24/7",
  },
];

// Data for the "Quick Links" column with icons
const quickLinksData = [
  { icon: FaUsers, text: "About Us", to: "aboutus" },
  { icon: FaFileInvoice, text: "ADM Policy", to: "Admpolicy" },
  { icon: FaLock, text: "Privacy Policy", to: "privacypolicy" },
  { icon: FaFileContract, text: "Terms And Conditions", to: "termandcondition" },
  { icon: FaUndoAlt, text: "Refund & Cancellation", to: "refundandcancellation" },
  {
    icon: FaPlane,
    text: "Travel Documents Requirements",
    to: "https://www.iatatravelcentre.com/passport-visa-health-travel-document-requirements.htm",
    isExternal: true,
  },
  { icon: FaBookOpen, text: "Booking Policy", to: "bookingpolicy" },
];

// Data for social media links
const socialLinks = [
  { icon: FaFacebookF, href: "https://www.facebook.com/travelchampbd/" }, // Replace # with your actual URL
  { icon: FaLinkedinIn, href: "https://www.linkedin.com/company/travelchamplimited/" },
  { icon: FaInstagram, href: "https://www.instagram.com/travelchamp.insta/" },
];

const Footer = () => {
  return (
    <>
      <Box bg="#0A2240" color="whiteAlpha.900">
        <Box
          className="container-fluid"
          px={{ base: "6", md: "8", lg: "10%" }} // MODIFIED: Increased base padding for mobile
          py={{ base: "10", lg: "16" }}
        >
          {/* Main Flex container for all columns */}
          <Flex
            direction={{ base: "column", lg: "row" }}
            justify="space-between"
            gap={{ base: "10", lg: "6" }}
            textAlign="left" // MODIFIED: Set to 'left' for all screen sizes
          >
            {/* Column 1: Contact Us */}
            <VStack align="start" spacing={5}> {/* MODIFIED: align="start" for all screens */}
              <Text fontSize="lg" fontWeight="600" color="#068B9F">Contact Us</Text>
              {contactData.map((item, idx) => (
                <HStack key={idx} spacing={4} w="full" justify="start"> {/* MODIFIED: justify="start" for all screens */}
                  <Icon as={item.icon} boxSize={5} color="whiteAlpha.800" />
                  <ChakraLink
                    href={item.link}
                    isExternal={item.isExternal}
                    fontSize="sm"
                    _hover={item.link ? { color: "white", textDecoration: 'underline' } : {}}
                    cursor={item.link ? 'pointer' : 'default'}
                    maxW="220px"
                  >
                    {item.text}
                  </ChakraLink>
                </HStack>
              ))}
            </VStack>

            {/* Column 2: Quick Links */}
            <VStack align="start" spacing={5}> {/* MODIFIED: align="start" for all screens */}
              <Text fontSize="lg" fontWeight="600" color="#068B9F">Quick Links</Text>
              {quickLinksData.map((item, idx) => (
                <HStack key={idx} spacing={4} w="full" justify="start"> {/* MODIFIED: justify="start" for all screens */}
                  <Icon as={item.icon} boxSize={5} color="whiteAlpha.800" />
                  {item.isExternal ? (
                    <ChakraLink href={item.to} isExternal fontSize="sm" _hover={{ color: "white", textDecoration: 'underline' }}>
                      {item.text}
                    </ChakraLink>
                  ) : (
                    <RouterLink to={`/${item.to}`}>
                      <Text as="span" fontSize="sm" _hover={{ color: "white", textDecoration: 'underline' }}>
                        {item.text}
                      </Text>
                    </RouterLink>
                  )}
                </HStack>
              ))}
            </VStack>

            {/* Column 3: Accredited By & Member Of */}
            <VStack align="start" > {/* MODIFIED: align="start" for all screens */}
              <Text fontSize="lg" fontWeight="600" color="#068B9F">Accredited By</Text>
              {/* MODIFIED: Wrapped logo in a white Box to match mobile design */}
              
                <img src={aita} alt="IATA Logo" style={{ height: "auto", maxWidth: "120px"}} />
            
              <Text fontSize="lg" fontWeight="600" color="#068B9F" >Member of</Text>
              <img src={Toab} alt="TOAB Logo" style={{ height: "auto", maxWidth: "120px" }} />
            </VStack>

            {/* Column 4: Travelchamp Info & Stay Connected */}
            <VStack align="start" spacing={4} w={{ lg: "25%" }}> {/* MODIFIED: align="start" for all screens */}
              <img src={logo} alt="Travelchamp Logo" style={{ width: "160px", marginBottom: '1rem' }}/>
              <Text fontSize="sm">TRADE Licence No: TRAD/DNCC/000732/2022</Text>
              <Text fontSize="sm">IATA No: 42343162</Text>
              <Text fontSize="sm">MoCAT No: 0013891</Text>
              <Text fontSize="sm" fontStyle="italic" pt={4} maxW="280px">
                Making air travel simple and accessible. — “let your dream take places.”
              </Text>
              <Text fontSize="lg" fontWeight="600" color="#068B9F" pt={6}>Stay Connected</Text>
              <Text fontSize="sm" fontWeight="bold">Follow us for travel deals & updates</Text>
              <HStack spacing={3} pt={2}>
                {socialLinks.map((social, idx) => (
                  <Circle as="a" href={social.href} target="_blank" key={idx} size="38px" bg="#068B9F" color="white" transition="all 0.3s" _hover={{ bg: "white", color: "#00AEEF" }}>
                    <Icon as={social.icon} />
                  </Circle>
                ))}
              </HStack>
            </VStack>

          </Flex>
        </Box>

        <Box borderY="1px solid #ededed" className="container-fluid">
          {/* <Box className="container">
          <img
            src={SSLCommerz}
            alt="footerlogo"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "5px",
            }}
          />
        </Box>
        <Text
          style={{
            display: "flex",
            color: "#068B9F",
            justifyContent: "center",
            alignItems: "center",
          }}
          fontWeight={500}
          fontSize={"20px"}
        >
          Concern of
        </Text>
        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "5px",
          }}
        >
          <img
            src={usbanglaAir}
            alt="footerlogo"
            style={{ height: "100px", width: "300px" }}
          />
        </Box> */}
        </Box>

        {/* Copyright Section */}
        <Box borderTop="1px solid" borderColor="whiteAlpha.300" py="4">
          <Text fontSize="sm" color="whiteAlpha.700" textAlign="center">
            Copyright © 2025 Travelchamp Ltd. All rights reserved.
          </Text>
        </Box>
      </Box>
    </>
  );
};

export default Footer;